var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8497_51213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3334 2C15.7016 2 16.0001 2.29848 16.0001 2.66667V6.66667C16.0001 7.03486 15.7016 7.33333 15.3334 7.33333H11.3334C10.9652 7.33333 10.6667 7.03486 10.6667 6.66667C10.6667 6.29848 10.9652 6 11.3334 6H14.6667V2.66667C14.6667 2.29848 14.9652 2 15.3334 2Z",
    fill: "#FB7B33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7516 2.72067C7.6067 2.55827 6.44002 2.77239 5.42739 3.33074C4.41476 3.8891 3.61103 4.76144 3.13732 5.81633C2.66361 6.87121 2.54559 8.05148 2.80103 9.17928C3.05647 10.3071 3.67154 11.3213 4.55356 12.0691C5.43557 12.8169 6.53674 13.2578 7.69113 13.3254C8.84553 13.3929 9.9906 13.0834 10.9538 12.4436C11.917 11.8037 12.6461 10.8681 13.0313 9.77777C13.154 9.43061 13.5348 9.24861 13.882 9.37126C14.2292 9.49391 14.4112 9.87476 14.2885 10.2219C13.807 11.5848 12.8956 12.7543 11.6916 13.5542C10.4876 14.354 9.05626 14.7409 7.61327 14.6564C6.17028 14.572 4.79381 14.0209 3.69129 13.0861C2.58877 12.1514 1.81994 10.8836 1.50063 9.47382C1.18133 8.06407 1.32886 6.58873 1.921 5.27012C2.51314 3.95152 3.5178 2.86108 4.78359 2.16314C6.04938 1.4652 7.50772 1.19756 8.93885 1.40055C10.3666 1.60306 11.69 2.26301 12.7108 3.28127L15.7903 6.18117C16.0583 6.43359 16.071 6.85551 15.8186 7.12356C15.5662 7.3916 15.1443 7.40427 14.8762 7.15186L11.7895 4.24519C11.7846 4.24057 11.7798 4.23587 11.775 4.2311C10.9576 3.41317 9.89651 2.88307 8.7516 2.72067Z",
    fill: "#FB7B33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8497_51213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.816009546e5d097d276a577fd70088e4.svg";
export { ForwardRef as ReactComponent };